<template lang="pug">
  .complete.box
    h1.has-text-weight-bold THANK YOU FOR YOUR  FIBRE ORDER
    p.has-text-weight-normal We have received your order and it is being processed.
    p.has-text-weight-normal You will receive an updated order number within one business day  and our team will be in touch to confirm your details and schedule a time and date for installation.
    p.has-text-blue.has-text-weight-bold(v-if="orderNumber") Your reference number is {{ orderNumber }}
    p.has-text-weight-normal Should you wish to follow up on your order you can contact our call centre on {{ phoneNumber }}
    LeaveReview
    p.has-text-weight-normal We’re Social, Follow Us!
    p
      a.has-text-blue(:href="facebookLink" target="_blank" style="margin-right:10px")
        fa-icon(:icon="['fab', 'facebook-square']", size="2x")
      a.has-text-blue(v-if="showLinkedin" :href="linkedinLink" target="_blank")
        fa-icon(:icon="['fab', 'linkedin']", size="2x")

</template>

<script>
  import store from '@/store'
  import brand from "@/brand"
  import LeaveReview from "@/components/LeaveReview.vue";

  export default {
    components: {
      LeaveReview
    },
    data() {
      return {
        orderNumber: store.state.orderNumber
      }
    },
    computed: {
      showLinkedin() {
        const show = {
          "cybersmart" : true,
          "ftta": true,
          "gigalight" : false,
        };

        return show[brand.getBrand()];
      },
      linkedinLink() {
        const links = {
          "cybersmart" : "https://www.linkedin.com/company/cybersmart-pty-ltd",
          "ftta"       : "https://www.linkedin.com/company/fttasouthafrica/",
          "gigalight"  : "",
        };

        return links[brand.getBrand()];
      },
      facebookLink() {
        const links = {
          "cybersmart" : "https://www.facebook.com/CybersmartSA",
          "ftta"       : "https://www.facebook.com/Fibre-to-the-Apartment-683208105385551/",
          "gigalight"  : "https://www.facebook.com/gigalight.fibre",
        };

        return links[brand.getBrand()];
      },
      phoneNumber() {
        const phones = {
          "cybersmart" : "021 | 031 | 010 286 0127",
          "ftta"       : "021 286 3882",
          "gigalight"  : "054 332 2290",
        };

        return phones[brand.getBrand()];
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";
  @import "../styles/variables";

  .complete {
    margin: 3rem 3rem 0 3rem;
    text-align: left;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100%;
    justify-content: left;
    @include until($desktop) {
      flex-direction: column;
    }

    h1 {
      font-size: 2rem;
      line-height: 1.125;
      margin-bottom: 2rem;
    }

    p {
      margin-bottom: 2rem;
    }

    .has-text-blue {
      color: $primary;
    }
  }
</style>
